import { AnalyticsEvent } from "./analyticsEvent"
class LeftHandNavEvent extends AnalyticsEvent {
    public lhNavLink: string;
    constructor(lhNavLink: string) {
        super();
        this.lhNavLink = lhNavLink;
    }
}
export { LeftHandNavEvent }